/**
 * Config
 */
import L10N from './Lang';
import GameInfo from './GameInfo';
import Util from './Util';

const setDefaultPath = (path: string) => {
  return path || '/';
};

const win = window as any;

const Config: any = {
  v: Util.DataFilter.filter(
    [
      { v: '1.0.0', isActive: false },
      { v: '1.0.4-1', isActive: false },
      { v: '1.1.0-0', isActive: false },
      { v: '1.1.0-2', isActive: false },
      { v: '1.1.4-2', isActive: false },
      { v: '1.2.9-2', isActive: false },
      { v: '1.3.8-2', isActive: false },
      { v: '1.3.17-2', isActive: false },
      { v: '1.4.11-2', isActive: false },
      { v: '1.5.0-2', isActive: true }
    ],
    { isActive: true }
  ),

  __secretArticleId: '',

  currentCommentIdForUpload: '',

  guid: win.userData && win.userData.guid ? win.userData.guid : '',

  now: win.userData && win.userData.now ? win.userData.now : '',

  nickName: win.userData && win.userData.ncAccount && win.userData.ncAccount.name ? win.userData.ncAccount.name : '',

  serverId: win.userData && win.userData.gameAccount && win.userData.gameAccount.serverId ? win.userData.gameAccount.serverId : '',

  gameServerName: win.userData && win.userData.gameAccount && win.userData.gameAccount.serverName ? win.userData.gameAccount.serverName : '',

  gameUserUid: win.userData && win.userData.gameAccount && win.userData.gameAccount.gameUserUid ? win.userData.gameAccount.gameUserUid : '',

  gameName: win.userData && win.userData.gameAccount && win.userData.gameAccount.name ? win.userData.gameAccount.name : '',

  accountStateCase: win.userData && win.userData.accountState && win.userData.accountState.case ? win.userData.accountState.case : '',

  accountStateMsg: win.userData && win.userData.accountState && win.userData.accountState.msg ? win.userData.accountState.msg : '',

  // emoticon image size
  attachedEmoticonsSize: {
    w: 140,
    h: 140
  },

  // using _user_ API
  userGuid: '',

  // N-Community
  isUuid: true,

  // L20N, default: ko
  L10N: L10N[jQuery('html').attr('lang') || 'ko'],

  // 게시판 종류, default: free
  board: 'free',

  viewBoardAlias: '',

  viewBoardObserver: new Util.Observer(),

  site: '',

  share: {},

  isNcAccount: false,

  isNcAndGameAccount: false,

  listViewMode: 'list',

  isListView: true,

  isCardView: false,

  isThumbView: false,

  isInfinite: true,

  isAdmin: false,

  isWrite: true,

  isShare: true,

  isImage: false,

  isMovie: false,

  isShowSignature: true,

  isShowViewUtil: true,

  isListShare: false,

  isViewImageMaxWidth: true,

  listSize: 20,

  commentListSize: 20,

  isMultiCommentArticleId: false,

  isShowTitle: true,

  isHideViewInfo: false,

  isLike: true,

  // @TODO remove
  isCategory: false,

  isShowCategory: false,

  isShowCategoryAll: false,

  isShowCategory2Depth: false,

  isShowCategory2DepthAll: false,

  isShowCategory2DepthTotal: false,

  isShowWriteCategory: true,

  isShowSearchResult: true,

  isSandBoxLike: false,

  isListArticleDelete: false,

  isListCommentDelete: false,

  isListBookmarkDelete: false,

  isBookmark: true,

  isBookmarkMessage: true,

  bookmarkUrl: '/my/profile/board/bookmark',

  // comment option
  isPaging: false,

  isNoReply: false,

  isUserInfoWithServer: true,

  isListLinkTargetBlank: false,

  isMyProfile: true,

  // profileUrl: `/profile/character/{accountId}{serverId}/{charId}board/list`,
  //
  // myProfileUrl: `/my/profile/board/list`,
  //
  // characterUrl: `/profile/user/{guid}/board/list`,
  //
  // myCharacterUrl: `/my/profile/character`,

  isShowBtnList: true,

  isGameSignature: true,

  useMobileImage: true,

  isBnsApp: false,

  isShowPrevNextArticle: false,

  // @TODO default: false
  isShowPrevNextNavigation: false,

  prevNextNavigationSize: 30,

  isEmoticon: false,

  isCommentArticleOwner: false,

  isCommentUpload: false,

  isSvgLoaded: false,

  commentUploadTokenUrl: '',

  commentTokenFileInfoUrl: '',

  isCommentEmoticon: false,

  isShowNoticeComment: false,

  isCommentUpdate: false,

  commentPlaceholder: '',

  onHookSubmitBefore: '',

  onHookWriteBefore: () => {
    return true;
  },

  onHookCommentWriteBefore: () => {
    return true;
  },

  isProfileWithCharId: false,

  isProfileWithGameAccountId: false,

  isListCount: false,

  isDefaultViewMode: 'list',

  isHideGameAccountId: false,

  _isHideCommentProfile: false,

  useAPIListUrl: true,

  isUsingSearchContents: true,

  isUsingSearchTitle: true,

  isUsingSearchWriter: true,

  isUsingSearchTag: false,

  isShowSearchForm: true,

  isShowReload: true,

  isVote: false,

  isTag: false,

  usePlusTag: true,

  tagSearchLink: (tag: any) => `${win._tagPath || '/'}search/tag?query=${tag}`,

  isSpeech: false,

  isWriteAllBoard: false,

  isDisabledWriteCategory: false,

  isBookmarkDelete: false,

  isArticleDelete: false,

  emoticons: [],

  commentUploadFrame: `${setDefaultPath(win._path)}html/commentUpload.html`,

  commentTextMaxCount: 300,

  // 이전/다음 데이터
  prevNextData: '',

  viewData: '',

  isReversePrevNext: false,

  checkWriteNotExistGameAccount: false,

  // When this option is enabled, top notice will display.
  isTopNotice: false,

  // When disabled, top notice will display list type.
  isTopNoticeSwipe: false,

  isShowCategory1DepthValue: false,

  isHideCommentToList: false,

  isShowCommentOrderType: true,

  isCommentOrderByAsc: false,

  isShowCommentTotalCount: true,

  // day
  setLegacyEventDate: 0,

  // 'desc', 'asc', 'good'
  commentOrderByDefault: 'good',

  commentOrderByDesc: 'desc',

  commentOrderByAsc: 'asc',

  commentOrderByGood: 'good',

  adminCommentImg: 'https://wstatic-cdn.plaync.com/resource/plaync/profile.jpg',

  loginPage: 'https://mlogin.plaync.com/login/signin',

  defaultCommentProfileImage: '',

  allowWriteWithAllCatecory: false,

  allowOnBeforeUnloadAlert: true,

  allowOwnerToDeleteComment: false,

  COMMUNITY_NODE: 'uikit-nccommunity-node',

  isOwnerOfArticle: false,

  COMMENT_ANCHOR_NAME: 'comment',

  isLogin: () => {
    const _login = win.userData && win.userData.isLogin;

    if (Config.isBnsApp) {
      return true;
    }

    return _login || false;
  },

  // GET, Permission 조회
  permissions: `${setDefaultPath(win._path)}board/permissions`,

  // GET, 태그 조회. 초성, 일반단어 자동완성 검색 기능.
  tagSearch: `${setDefaultPath(win._tagPath)}tag/search`,

  // GET, 추천태그 조회. NLP에서 제공되는 추천태그.
  tagRecmd: `${setDefaultPath(win._tagPath)}tag/recmd`,

  // POST, 태그가 첨부된 게시글 등록. | DELETE, 게시글 삭제
  tagContent: `${setDefaultPath(win._tagPath)}tag/content/exact`,

  // POST, 태그가 첨부된 게시글 등록. | DELETE, 게시글 삭제 - 혈맹게시판 예외처리
  tagContentGuild: `${setDefaultPath(win._tagPath)}tag/guild_content/exact`,

  // GET, 게시글 태그 조회
  tagAttached: (data: any) => `${setDefaultPath(win._tagPath)}tag/attachedTag?articleId=${data.articleId}&category=${data.categoryId}`,

  // GET, 하위 카테고리 목록 조회
  category: (board: any) => `${setDefaultPath(win._path)}board/${board}/category`,

  // GET, 하위 카테고리 목록 조회 - 2depth
  category2depth: (board: any) => `${setDefaultPath(win._path)}board/${board}/depthCategory`,

  // GET, 글 목록 + pageing
  list: (board: any) => `${setDefaultPath(win._path)}board/${board}/article`,

  // GET, 전체 검색
  allList: (board: any) => `${setDefaultPath(win._path)}board/${board}/articles`,

  // GET, 포인트 등급
  gradeList: () => `${setDefaultPath(win._path)}profile/grade`,

  listMore: (board: any) => `${setDefaultPath(win._path)}board/${board}/article/search/moreArticle`,

  listMoreAll: (board: any) => `${setDefaultPath(win._path)}board/${board}/article/search/moreArticles`,

  // GET, 글 보기
  view: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}${data.categoryId !== '0' ? `?categoryId=${data.categoryId}` : ``}`,

  // GET, 댓글 목록 / 내가 좋아요한 댓글 fields=vote
  comment: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/comment`,
  commentVote: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/comment
	?fields=vote
	&size=${data.size || 20}
	&page=${data.page || 1}
	&orderType=${data.orderType || Config.commentOrderByDefault}`,

  // 댓글 작성
  commentWrite: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/comment`,

  // 댓글 수정
  commentUpdate: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/comments`,

  // set writer.emoticonUrl
  commentAdmin: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/operator/comment`,

  // GET, 댓글 목록 더보기  / 내가 좋아요한 댓글 더보기 fields=vote
  commentMore: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/comment/search/moreComment
	?previousCommentId=${data.commentId}
	&moreSize=${data.moreSize || 20}
	&moreDirection=${data.moreDirection || 'BEFORE'}
	&fields=${data.fields || ''}
	&orderType=${data.orderType || Config.commentOrderByDefault}`,

  commentMoreVote: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/comment/search/moreComment
	?fields=vote&previousCommentId=${data.commentId}
	&moreSize=${data.moreSize || 20}
	&moreDirection=${data.moreDirection || 'BEFORE'}
	&fields=${data.fields || ''}
	&orderType=${data.orderType || Config.commentOrderByDefault}`,

  // DELETE, 댓글 삭제
  commentRemove: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/comment/${data.commentId}`,

  // POST, 글 신고
  reportArticle: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/reportArticle`,

  // POST, 댓글 신고
  reportComment: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/comment/${data.commentId}/reportComment`,

  // GET, 글 신고 횟수
  todayReportedCount: () => `${setDefaultPath(win._path)}board/_my_/todayReportedCount`,

  // DELETE, 댓글 추천 취소 | POST, 댓글 추천
  voteComment: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/comment/${data.commentId}/voteComment`,

  // POST, 글 쓰기 | POST, 답글 쓰기
  write: (board: any) => `${setDefaultPath(win._path)}board/${board}/article`,

  // PUT, 글 수정
  update: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}`,

  // DELETE, 글 삭제
  delete: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}`,

  // POST, 글 좋아요
  vote: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/voteArticle`,

  // GET, 이전 다음글 가져오기
  prevNext: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/prevNext`,

  // GET, 상단 공지 목록
  noticeList: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/noticeArticle`,

  // GET, 상단 공지 뷰페이지
  noticeView: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/noticeArticle/${data.articleId}`,

  // POST, 스크랩 하기
  scrap: (data: any) =>
    Config.isUuid ? `${setDefaultPath(win._path)}board/_my_/scrapArticle/${data.board}/${data.articleId}` : `${setDefaultPath(win._path)}board/_my_/scrapArticle/${data.articleId}`,

  // DELETE, 스크랩 삭제
  scrapDelete: (data: any) =>
    Config.isUuid
      ? `${setDefaultPath(win._path)}board/_my_/scrapArticle/${data.boardAlias}/${data.articleId}`
      : `${setDefaultPath(win._path)}board/_my_/scrapArticle/${data.articleId}`,

  // GET, 스크랩 여부
  isScrap: (data: any) => `${setDefaultPath(win._path)}board/_my_/isScrapArticle/${data.articleId}`,

  // GET, 스크랩 목록
  scrapList: (data: any) => `${setDefaultPath(win._path)}board/_my_/scrapArticle`,

  // GET, 스크랩 목록
  moreScrapList: (data: any) => `${setDefaultPath(win._path)}board/_my_/scrapArticle/search/moreScrapArticle`,

  // GET, 이전, 다음 게시글 리스트 조회
  prevNextCombine: (data: any) => `${setDefaultPath(win._path)}board/${data.board}/article/${data.articleId}/prevNextCombine?categoryId=${data.categoryId}`,

  // GET, 내가 혹은 타인이 작성한 글 리스트
  myArticle: (isUser: any = false) => `${setDefaultPath(win._path)}board/${isUser ? `_user_` : `_my_`}/article`,

  // GET, 내가 혹은 타인이 작성한 글 리스트
  myMoreArticle: (isUser: any = false) => `${setDefaultPath(win._path)}board/${isUser ? `_user_` : `_my_`}/article/search/moreArticle`,

  // GET, 내가 혹은 타인이 작성한 댓글 리스트
  myCommentArticle: (isUser: any = false) => `${setDefaultPath(win._path)}board/${isUser ? `_user_` : `_my_`}/commentedArticle`,

  // GET, 내가 혹은 타인이 작성한 댓글 리스트
  myMoreCommentArticle: (isUser: any = false) => `${setDefaultPath(win._path)}board/${isUser ? `_user_` : `_my_`}/commentedArticle/search/moreCommentedArticle`,

  // GET, 내가 혹은 타인이작성한 글 카운트
  myArticleCount: (isUser: any = false) => `${setDefaultPath(win._path)}board/${isUser ? `_user_` : `_my_`}/article/search/totalCount`,

  // GET, 내가 혹은 타인이 작성한 댓글 리스트
  myComment: (isUser: any = false) => `${setDefaultPath(win._path)}board/${isUser ? `_user_` : `_my_`}/commentedArticle`,

  // GET, 내가 혹은 타인이 작성한 댓글 카운트
  myCommentCount: (isUser: any = false) => `${setDefaultPath(win._path)}board/${isUser ? `_user_` : `_my_`}/commentedArticle/search/totalCount`,

  profileCharacter: (gameAccountId: string, serverId: string, charId: string = '') => {
    const _serverId = serverId ? `/${serverId}` : ``;
    const _charId = charId ? `/${charId}` : ``;
    const _gameAccountId = gameAccountId ? `/${gameAccountId}` : ``;

    return Config.isHideGameAccountId
      ? `${setDefaultPath(win._path)}profile/character${_serverId}${_charId}`
      : `${setDefaultPath(win._path)}profile/character${_gameAccountId}${_serverId}${_charId}`;
  },

  profileCharacterByCharacterId: (serverId: string, charId: string = '', gameCode: number) => {
    let _url = '';

    if (win.userData && win.userData.site === 'aion') {
      _url = `${setDefaultPath(win._path)}game/v1/characters/server/${serverId}/id/${charId}`;
    }

    if (win.userData && win.userData.site === 'bns') {
      _url = `${setDefaultPath(win._path)}game/v1/characters/servers/${serverId}/id/${charId}?gameCode=${gameCode}`;
    }

    return _url;
  },

  profileCharacterByCharacterName: (name: string, serverId: string, charId: string = '') => {
    let _url = `${setDefaultPath(win._path)}my/character/${serverId}/${name}`;

    if (win.userData && win.userData.site === 'lineage') {
      _url = `${setDefaultPath(win._path)}board/writer/servers/${serverId}/character/${name}/profile`;
    }

    if (win.userData && win.userData.site === 'lineage2') {
      _url = `${setDefaultPath(win._path)}board/writer/character/${serverId}/${name}`;
    }

    return _url;
  },

  // serverAPI
  serverNameUrl: `${setDefaultPath(win._path)}gamedata/serverNameMap`,

  // serverNameMap
  serverName: (() => {
    const _server: any =
      win.userData.site === 'bns'
        ? {
            LIVE: {},
            FRONTIER: {}
          }
        : {};
    const _serverNameMap = win._serverNameMap;

    if (!_serverNameMap) {
      return _server;
    }

    jQuery.each(_serverNameMap, (idx, item) => {
      const _serverType: string = item.serverType;
      const _serverId: string = item.serverId;
      const _serverName: string = item.serverName;
      const _itemId: string = item.id;
      const _itemName: string = item.name;

      if (!!_serverType && win.userData.site === 'bns') {
        _server[_serverType][_serverId] = _serverName;
      } else {
        if (_serverId && _serverName) {
          _server[_serverId] = _serverName;
        } else if (_itemId && _itemName) {
          _server[_itemId] = _itemName;
        }
      }
    });
    return _server;
  })(),

  serverType: '',

  getFavTeamIdByName: (name: string) => {
    const _names = win._serverNameMap;
    const nameKey = 'name';
    const idKey = 'id';
    let _id = '';

    if (!_names) {
      return _id;
    }

    jQuery.each(_names, (idx, item) => {
      if (item[nameKey] === name) {
        _id = item[idKey];
        return false;
      }
    });

    return _id;
  },

  getServerIdByName: (name: string) => {
    const _serverNames = win._serverNameMap;
    const nameKey = 'name';
    const serverIdKey = 'serverId';
    const serverNameKey = 'serverName';
    let _serverId = '';

    if (!_serverNames) {
      return _serverId;
    }

    jQuery.each(_serverNames, (idx, item) => {
      if (item[serverNameKey] === name || item[nameKey] === name) {
        _serverId = item[serverIdKey];
        return false;
      }
    });
    return _serverId;
  },

  // 리스트 페이지 url
  listPage: 'list',

  // 뷰 페이지 url
  viewPage: 'view',

  // 글 쓰기 / 글 수정 페이지 url
  writePage: 'write',

  // 리스트에서 뷰페이지 이동시 추가할 경로
  apiError: (data: any, loginPage: any) => {
    const msg = L10N[jQuery('html').attr('lang') || 'ko'];

    if (data.responseJSON) {
      data = data.responseJSON;
    }

    const errorCode = data.errorCode;
    const errorCodeResult = data.result && data.result.errorCode ? data.result.errorCode : '';
    let status = data.status || '';
    status = status.toString();

    if (errorCodeResult === 'COMMUNITY_NOT_SERVERMASTER') {
      // TODO L10N
      Config.alert('서버지기가 아닙니다.');
      return;
    }

    if (errorCodeResult === 'COMMUNITY_WRONG_SERVERMASTER_SERVER') {
      // TODO L10N
      Config.alert('해당 서버의 서버지기가 아닙니다.');
      return;
    }

    if (errorCodeResult === 'COMMUNITY_WRONG_SERVERMASTER_CHARACTER') {
      Config.alert('선택하신 계정이 해당 서버의 서버지기가 아닙니다.');
      return;
    }

    if (
      win.userData &&
      win.userData.site === 'aion' &&
      (data.exceptionClassName === 'RepresentativeCharacterNotFoundException' || data.exceptionClassName === 'UnsupportedCharacterLevelException')
    ) {
      Config.alert('서비스 이용을 위해서는 10레벨 이상의 캐릭터를 선택하셔야 합니다.');
      return;
    }

    if (win.userData && win.userData.site === 'bns' && data.exceptionClassName === 'RepresentativeCharacterNotFoundException') {
      Config.alert('서비스 이용을 위해 대표캐릭터를 선택해주세요.');
      return;
    }

    if (win.userData && win.userData.site === 'bns' && data.exceptionClassName === 'UnsupportedCharacterLevelException') {
      Config.alert('서비스 이용을 위해 9레벨 이상의 대표캐릭터를 선택해주세요.');
      return;
    }

    if (data.exceptionClassName === 'BnsUnauthorizedException') {
      Config.alert('본인확인이 필요합니다.');
      return;
    }

    if (
      (data && data.toString() === '2002') ||
      data.message === 'banned' ||
      data.message === 'Banned account.' ||
      data.exceptionClassName === 'BannedException' ||
      (data.result && data.result.exceptionClassName === 'BannedException')
    ) {
      Config.alert(msg.alert_banned);
      return;
    }

    if (errorCode && errorCode.toString() === '2001') {
      Config.alert(msg.WORLD_SELECTED_CHARACTER_NOTFOUND);
      return;
    }

    // 로그인 페이지로 이동되는 예외처리 이슈는 마지막에 실행되도록 변경.
    if (
      status === '401' ||
      data === '400' ||
      data === '101' ||
      data === '503' ||
      errorCode === '3000' ||
      data.exceptionClassName === 'AccessDeniedException' ||
      (data.result && data.result.exceptionClassName === 'AccessDeniedException')
    ) {
      Config.alert(msg.alert_login);

      if (win.GNBLogin) {
        win.GNBLogin();
      }

      return;
    }

    if (data.result && data.result.message) {
      Config.alert(data.result.message);
      return;
    }
  },

  // API에러처리
  prefixPath: '',

  alert(msg: string) {
    win.alertMessage ? win.alertMessage(msg) : win.alert(msg);
  },

  confirm(msg: string, resolve: any, reject: any) {
    if (win.confirmMessage) {
      win.confirmMessage(msg, resolve, reject);
    } else {
      const r = win.confirm(msg);
      if (r) {
        resolve();
      } else {
        reject();
      }
    }
  },

  bnsServerType: {
    LIVE: 54,
    FRONTIER: 154
  },

  app: {
    banned: (net: string) => `http://${net}a.bns.plaync.com/bnsapi/board/user/banned`,
    report: 'bns://report',
    viewer: 'noob://bns/image/view',
    popup: 'noob://bns/webRequestPopup?cmd=open&url='
  },

  onSandboxLike(count: number | string, $node: any) {
    // onSandboxLike;
  }
};

export default Config;
